// Vehicles
export const webPageSpeakableVehicles = {
  "@context": "https://schema.org/",
  "@type": "WebPage",
  name: "Turno - Electric Vehicles Piaggio ape, Mahindra Treo zor, E-treo, OSM",
  image: [
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/PiaggioVehicleThumbnail/Piaggio.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/MahindraVehicleThumbnail/Mahindra-electric2.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/ETrioVehicleThumbnail/e1.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/OSMVehicleThumbnail/OSM.jpg",
  ],
  primaryImageOfPage: {
    "@type": "ImageObject",
    name: "https://assets.turnoclub.com/developer/offer-turno-images/S3/PiaggioVehicleThumbnail/Piaggio.jpg",
  },
  speakable: {
    "@type": "SpeakableSpecification",
    xPath: [
      "/html/head/title",
      "/html/head/meta[@name='description']/@content",
    ],
  },
  url: "https://www.turno.club/vehicles",
};

export const searchWebSiteVehicles = {
  "@context": "http://schema.org",
  "@type": "WebSite",
  url: "https://www.turno.club/vehicles",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://www.turno.club/vehicles?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

//Piaggio Ape
export const webPageSpeakablePiaggioApe = {
  "@context": "https://schema.org/",
  "@type": "WebPage",
  name: "Piaggio Ape Electrik",
  image: [
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/piaggio/jpg/p1.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/piaggio/jpg/p2.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/piaggio/jpg/p3.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/piaggio/jpg/p4.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/piaggio/jpg/p5.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/piaggio/jpg/p6.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/piaggio/jpg/p7.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/piaggio/jpg/p8.jpg",
  ],
  primaryImageOfPage: {
    "@type": "ImageObject",
    name: "https://assets.turnoclub.com/developer/offer-turno-images/S3/PiaggioVehicleThumbnail/Piaggio.jpg",
  },
  speakable: {
    "@type": "SpeakableSpecification",
    xPath: [
      "/html/head/title",
      "/html/head/meta[@name='description']/@content",
    ],
  },
  url: "https://www.turno.club/vehicles/piaggio/",
};

export const searchWebSitePiaggioApe = {
  "@context": "http://schema.org",
  "@type": "WebSite",
  url: "https://www.turno.club/vehicles/piaggio/",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://www.turno.club/vehicles/?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

// Mahindra treo
export const webPageSpeakableMahindra = {
  "@context": "https://schema.org/",
  "@type": "WebPage",
  name: "Mahindra Treo Zor",
  image: [
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/mahindra/jpg/m1.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/mahindra/jpg/m2.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/mahindra/jpg/m3.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/mahindra/jpg/m4.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/mahindra/jpg/m5.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/mahindra/jpg/m6.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/mahindra/jpg/m7.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/mahindra/jpg/m8.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/mahindra/jpg/m9.jpg",
  ],
  primaryImageOfPage: {
    "@type": "ImageObject",
    name: "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/mahindra/jpg/m1.jpg",
  },
  speakable: {
    "@type": "SpeakableSpecification",
    xPath: [
      "/html/head/title",
      "/html/head/meta[@name='description']/@content",
    ],
  },
  url: "https://www.turno.club/vehicles/mahindra",
};

export const searchWebSiteMahindra = {
  "@context": "http://schema.org",
  "@type": "WebSite",
  url: "https://www.turno.club/vehicles/mahindra",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://www.turno.club/vehicles/mahindra?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

// Etrio

export const webPageSpeakableEtrio = {
  "@context": "https://schema.org/",
  "@type": "WebPage",
  name: "ETRIO Touro MAX+",
  image: [
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/etrio/jpg/e1.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/etrio/jpg/e2.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/etrio/jpg/e3.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/etrio/jpg/e4.jpg",
  ],
  primaryImageOfPage: {
    "@type": "ImageObject",
    name: "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/etrio/jpg/e1.jpg",
  },
  speakable: {
    "@type": "SpeakableSpecification",
    xPath: [
      "/html/head/title",
      "/html/head/meta[@name='description']/@content",
    ],
  },
  url: "https://www.turno.club/vehicles/ETRIO",
};

export const searchWebSiteEtrio = {
  "@context": "http://schema.org",
  "@type": "WebSite",
  url: "https://www.turno.club/vehicles/ETRIO",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://www.turno.club/vehicles/ETRIO?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

// OSM
export const webPageSpeakableOSM = {
  "@context": "https://schema.org/",
  "@type": "WebPage",
  name: "OSM Rage +",
  image: [
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/osm/jpg/o1.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/osm/jpg/o2.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/osm/jpg/o3.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/osm/jpg/o4.jpg",
  ],
  primaryImageOfPage: {
    "@type": "ImageObject",
    name: "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/osm/jpg/o1.jpg",
  },
  speakable: {
    "@type": "SpeakableSpecification",
    xPath: [
      "/html/head/title",
      "/html/head/meta[@name='description']/@content",
    ],
  },
  url: "https://www.turno.club/vehicles/OSM",
};

export const searchWebSiteOSM = {
  "@context": "http://schema.org",
  "@type": "WebSite",
  url: "https://www.turno.club/vehicles/OSM",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://www.turno.club/vehicles/OSM?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

// Mahindra Treo Blog

export const webPageSpeakableMahindraTreoBlog = {
  "@context": "https://schema.org/",
  "@type": "WebPage",
  name: "Mahindra Treo Zor",
  image: [
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/mahindra/jpg/m1.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/mahindra/jpg/m2.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/mahindra/jpg/m3.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/mahindra/jpg/m4.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/mahindra/jpg/m5.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/mahindra/jpg/m6.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/mahindra/jpg/m7.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/mahindra/jpg/m8.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/mahindra/jpg/m9.jpg",
  ],
  primaryImageOfPage: {
    "@type": "ImageObject",
    name: "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/mahindra/jpg/m1.jpg",
  },
  speakable: {
    "@type": "SpeakableSpecification",
    xPath: [
      "/html/head/title",
      "/html/head/meta[@name='description']/@content",
    ],
  },
  url: "https://www.turno.club/blog/mahindra-treo-zor",
};

export const searchWebSiteMahindraTreoBlog = {
  "@context": "http://schema.org",
  "@type": "WebSite",
  url: "https://www.turno.club/blog/mahindra-treo-zor",
  potentialAction: {
    "@type": "SearchAction",
    target:
      "https://www.turno.club/blog/mahindra-treo-zor?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

// Piaggio Ape Blog

//Piaggio Ape
export const webPageSpeakablePiaggioApeBlog = {
  "@context": "https://schema.org/",
  "@type": "WebPage",
  name: "Piaggio Ape Electrik",
  image: [
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/piaggio/jpg/p1.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/piaggio/jpg/p2.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/piaggio/jpg/p3.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/piaggio/jpg/p4.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/piaggio/jpg/p5.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/piaggio/jpg/p6.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/piaggio/jpg/p7.jpg",
    "https://assets.turnoclub.com/developer/offer-turno-images/S3/360DegreeView/piaggio/jpg/p8.jpg",
  ],
  primaryImageOfPage: {
    "@type": "ImageObject",
    name: "https://assets.turnoclub.com/developer/offer-turno-images/S3/PiaggioVehicleThumbnail/Piaggio.jpg",
  },
  speakable: {
    "@type": "SpeakableSpecification",
    xPath: [
      "/html/head/title",
      "/html/head/meta[@name='description']/@content",
    ],
  },
  url: "https://www.turno.club/blog/piaggio-ape/",
};

export const searchWebSitePiaggioApeBlog = {
  "@context": "http://schema.org",
  "@type": "WebSite",
  url: "https://www.turno.club/blog/piaggio-ape/",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://www.turno.club/blog/piaggio-ape/?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};
